var focusHelper = require("base/components/focus");
const { updateCartTotals } = require("../components/cartHelper");
var applePayExpress = require("customadyen/applePayExpress");
const { isIOSDevice } = require("customadyen/adyen_checkout/helpers");

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($("#quickViewModal").hasClass("show") && !$(".product-set").length) {
        pid = $($el).closest(".modal-content").find(".product-quickview").data("pid");
    } else if ($(".product-set-detail").length || $(".product-set").length) {
        pid = $($el).data("pid");
    } else {
        pid = $(".product-detail:not('.bundle-item')").data("pid");
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $el.hasClass("js-loyalty-premium")) {
        quantitySelected = $(".js-loyalty-quantity");
    } else if ($el && $(".set-items").length) {
        quantitySelected = $($el).closest(".product-detail").find(".quantity-select");
    } else if ($el && $(".product-bundle").length) {
        var quantitySelectedModal = $($el).closest(".modal-footer").find(".quantity-select");
        var quantitySelectedPDP = $el.closest(".product-detail-sticky").length ?
            $(".bundle-footer").find(".quantity-select")
            : $($el).closest(".bundle-footer").find(".quantity-select");
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else if ($($el).hasClass("pdp-btn")) {
        quantitySelected = $(".quantity-select.pdp-select");
    } else {
        quantitySelected = $(".quantity-select");
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find("[data-attr='" + attr.id + "'] [data-attr-value='" +
            attrValue.value + "']");
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass("selected");
            $attrValue.siblings(".selected-assistive-text").text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass("selected");
            $attrValue.siblings(".selected-assistive-text").empty();
        }

        if (attrValue.url) {
            $swatchButton.attr("data-url", attrValue.url);
        } else {
            $swatchButton.removeAttr("data-url");
        }

        // Disable if not selectable
        $attrValue.removeClass("selectable unselectable");

        $attrValue.addClass(attrValue.selectable ? "selectable" : "unselectable");
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = "[data-attr='" + attr.id + "']";
    var $defaultOption = $productContainer.find($attr + " .select-" + attr.id + " option:first");
    $defaultOption.attr("value", attr.resetUrl);
    var chosenProductList = [];

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + " [data-attr-value='" + attrValue.value + "']");

        // if displayValue is not in the chosenProductList
        // then push the product in side of the chosenProductList
        if (chosenProductList.indexOf(attrValue.displayValue.toLowerCase()) == -1) {
            // added to check for duplicates as it is done in detail.js
            // in the packagingPDP function
            chosenProductList.push(attrValue.displayValue.toLowerCase());

            $attrValue.attr("value", attrValue.productURL)
                .removeAttr("disabled");

            if (!attrValue.selectable) {
                $attrValue.attr("disabled", true).closest(".form-group").addClass("d-none");
            } else {
                $attrValue.closest(".form-group").removeClass("d-none");
            }
        } else {
            $attrValue.attr("disabled", true).closest(".form-group").addClass("d-none");
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ["color"];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = "";
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = "<li><div>" + response.resources.info_selectforstock + "</div></li>";
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += "<li><div>" + message + "</div></li>";
        });
    }

    $($productContainer).trigger("product:updateAvailability", {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return "";
    }

    var html = "";

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === "mainAttributes") {
            attributeGroup.attributes.forEach(function (attribute) {
                html += "<div class='attribute-values'>" + attribute.label + ": "
                    + attribute.value + "</div>";
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find(".product-options").empty().html(optionsHtml);
}

/**
 * Disable main CTA if product has no stock
 * @param {Object} - product
 */
function handleCTAState(product) {
    if (!product.availabilityInfo.isInStock) {
        $(".js-add-to-cart-main .add-to-cart").attr("disabled", true).addClass("preorder-not-available");
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents(".choose-bonus-product-dialog").length > 0;
    var isVariant;
    var quantityPrice = response.product.quantityPrice;
    var $priceWrapper = $productContainer.find(".add-to-cart .prices");

    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVariant = response.product.productType === "variant";
        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer.parent(".bonus-product-item")
                .data("pid", response.product.id);

            $productContainer.parent(".bonus-product-item")
                .data("ready-to-order", response.product.readyToOrder);
        }
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $(".prices .price", $productContainer).length
            ? $(".prices .price", $productContainer)
            : $(".prices .price");
        var $pricePerLiterBlock = $productContainer.find(".pdp-price-per-liter-value");
        var pricePerLiterValue = response.product.pricePerLitre;

        $priceSelector.replaceWith(response.product.price.html);
        $priceWrapper.html(response.product.price.html);

        if (quantityPrice && $priceWrapper.length) {
            $priceWrapper.html(quantityPrice);
        }

        if (pricePerLiterValue && $pricePerLiterBlock.length) {
            $pricePerLiterBlock.html(pricePerLiterValue);
        }
    }

    if (response.productSetData) {
        updateProductSetAddAllToCart(response.productSetData);
    }

    // Update promotions
    $productContainer.find(".promotions").empty().html(response.product.promotionsHtml);
    //$(".avalability-messages").remove();
    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find(".select-bonus-product");
        $selectButton.trigger("bonusproduct:updateSelectButton", {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $("button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global").trigger("product:updateAddToCart", {
            product: response.product, $productContainer: $productContainer
        }).trigger("product:statusUpdate", response.product);
        handleCTAState(response.product);
    }

    // Update attributes
    $productContainer.find(".main-attributes").empty()
        .html(getAttributesHtml(response.product.attributes));

    // Update nutrition info
    if (response.enableNutritionInfo) {
        const $nutri = $(".nutri");

        $.ajax({
            url: $("#productNutritionUrl").val(),
            method: "GET",
            data: {
                pid: response.product.id
            },
            success: function (response) {
                $nutri.html(response);
                $nutri.show();
            },
            error: function () {
                $nutri.hide();
            }
        });
    } else {
        $(".nutri").hide();
    }
}

/**
 * @description Updates the text of the main CTA button and disabled it if there is not stock.
 * @param {Object} product -
 */
function updateCTA(product) {
    if (!product) {
        return;
    }

    var availabilityInfo = product.availabilityInfo;
    var isMandatoryPersonalizable = product.personalization ? product.personalization.isCustoMandatory : false;
    var ctaLabel = availabilityInfo.ctaLabel;
    var buttonLabelFormated = ctaLabel.buttonLabelFormated;
    var hasStock = availabilityInfo.isInStock;
    var $CTABtn = $(`.js-add-to-cart-main .cart-and-ipay [data-pid=${product.id}]`);
    var $CTABDash = $CTABtn.find(".dash");
    var $CTABPrice = $CTABtn.find(".prices");
    var $preorderBox = $("#preorder-box");
    if (availabilityInfo.isExclusiveProduct || !availabilityInfo.isInStock) {
        $CTABtn.attr("disabled", "disabled");
    } else {
        $CTABtn.removeAttr("disabled", "disabled");
    }
    $CTABtn.find(".add-to-cart-label").text(buttonLabelFormated);
    $CTABtn.find("button").attr("data-product-ismandatorypersonalizable", isMandatoryPersonalizable);
    if (!hasStock) {
        $CTABDash.addClass("d-none");
        $CTABPrice.addClass("d-none");
    } else {
        $CTABDash.removeClass("d-none");
        $CTABPrice.removeClass("d-none");
        if (product.price && !$(".c-personalization-modal").is(":visible")) {
            $CTABPrice.text(product.price.sales.formatted);
        }
    }
    if ($preorderBox && !$preorderBox.hasClass("d-none") && (ctaLabel.buttonLabel === "OutOfStock" || ctaLabel.buttonLabel === "AddToCart")) {
        $preorderBox.addClass("d-none");
    }
    if ($preorderBox && $preorderBox.hasClass("d-none") && (ctaLabel.buttonLabel === "AvailableFrom" || ctaLabel.buttonLabel === "PreOrder")) {
        var preOrdeReleaseDate = ctaLabel.preOrderReleaseDateFormated;
        var $releaseDate = $preorderBox.find(".preorder-date .js-date-formatted");
        $releaseDate.text(preOrdeReleaseDate);
        $preorderBox.removeClass("d-none");
    }
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer, minOrderValue) {
    if ($productContainer.parent(".bonus-product-item").length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            if (quantity.value >= minOrderValue) {
                var selected = quantity.selected ? " selected " : "";
                return "<option value='" + quantity.value + "'  data-url='" + quantity.url + "'" +
                    selected + ">" + quantity.value + "</option>";
            }
        }).join("");
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer, targetElement) {
    if (selectedValueUrl) {
        if ($productContainer.hasClass("set-item")) {
            let productSetId = $(".product-set-detail[data-pid]").attr("data-pid");
            let $siblings = $productContainer.siblings(".set-item");

            selectedValueUrl = selectedValueUrl.concat(`&productSetId=${productSetId}`);
            let productSetQuantityArray = [];
            $siblings.each(function() {
                const $element = $(this);
                const pid = $element.attr("data-pid");
                const qty = $element.find(".quantity-select").val();
                productSetQuantityArray.push({pid, qty});
            });
            selectedValueUrl = selectedValueUrl.concat(`&productSetQuantityArray=${JSON.stringify(productSetQuantityArray)}`);
        }

        $("body").trigger("product:beforeAttributeSelect",
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: "GET",
            success: function (data) {
                if (data !== undefined && data.product !== undefined) {
                    updateCTA(data.product);
                    handleVariantResponse(data, $productContainer);
                    updateOptions(data.product.optionsHtml, $productContainer);
                    updateQuantities(data.product.quantities, $productContainer, data.isMinOrderQuantity);
                    data.updateImgCarousel = targetElement && targetElement.length;

                    if (targetElement !== undefined && targetElement.is(".variation-select")) {
                        $(".m-bottle .perbottle-price").html(data.product.price.html);
                    }

                    $("body").trigger("product:afterAttributeSelect",
                        { data: data, container: $productContainer });

                    if (isIOSDevice() && window.isApplePayExpressEnabled && window.isExpressPaymentsEnabled) {
                        applePayExpress.initializeCheckout();
                    }
                }

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
* Updates the product set add all to cart button
* @param {object} productSetData - the product set data object
* @param {string} productSetData.totalValue - the total value of the product set
* @param {boolean} productSetData.isAvailable - true if all products from the product set are available for purchase
*/
function updateProductSetAddAllToCart(productSetData) {
    let {totalValue, isAvailable} = productSetData;
    let $addAllToCartPriceBtn = $(".product-set-add-to-cart .add-to-cart");
    let $addAllToCartPriceLabel = $addAllToCartPriceBtn.find(".prices");

    if (!isAvailable) {
        $addAllToCartPriceBtn.attr("disabled");
    }

    if (totalValue) {
        $addAllToCartPriceLabel.text(totalValue);
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $(".add-to-cart-url").val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $("<div>").append($.parseHTML(html));

    var body = $html.find(".choice-of-bonus-product");
    var footer = $html.find(".modal-footer").children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $(".modal-body").spinner().start();

    if ($("#chooseBonusProductModal").length !== 0) {
        $("#chooseBonusProductModal").remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = "<!-- Modal -->"
        + "<div class='modal fade' id='chooseBonusProductModal' tabindex='-1' role='dialog'>"
        + "<span class='enter-message sr-only'></span>"
        + "<div class='modal-dialog choose-bonus-product-dialog'"
        + "data-total-qty='" + data.maxBonusItems + "'"
        + "data-UUID='" + data.uuid + "'"
        + "data-pliUUID='" + data.pliUUID + "'"
        + "data-addToCartUrl='" + data.addToCartUrl + "'"
        + "data-pageStart='0'"
        + "data-pageSize='" + data.pageSize + "'"
        + "data-moreURL='" + data.showProductsUrlRuleBased + "'"
        + "data-bonusChoiceRuleBased='" + data.bonusChoiceRuleBased + "'>"
        + "<!-- Modal content-->"
        + "<div class='modal-content'>"
        + "<div class='modal-header'>"
        + "    <span class=''>" + data.labels.selectprods + "</span>"
        + "    <button type='button' class='close pull-right' data-dismiss='modal'>"
        + "        <span aria-hidden='true'>&times;</span>"
        + "        <span class='sr-only'> </span>"
        + "    </button>"
        + "</div>"
        + "<div class='modal-body'></div>"
        + "<div class='modal-footer'></div>"
        + "</div>"
        + "</div>"
        + "</div>";
    $("body").append(htmlString);
    $(".modal-body").spinner().start();

    $.ajax({
        url: bonusUrl,
        method: "GET",
        dataType: "json",
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $("#chooseBonusProductModal .modal-body").empty();
            $("#chooseBonusProductModal .enter-message").text(response.enterDialogMessage);
            $("#chooseBonusProductModal .modal-header .close .sr-only").text(response.closeButtonText);
            $("#chooseBonusProductModal .modal-body").html(parsedHtml.body);
            $("#chooseBonusProductModal .modal-footer").html(parsedHtml.footer);
            $("#chooseBonusProductModal").modal("show");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
var timer;
function handlePostCartAdd(response) {
    const $minicart = $(".minicart");
    const $header = $(".page-header");
    const $minicartPopover = $header.find(".minicart-popover");
    const messageType = response.error ? "alert-danger" : "alert-success";

    clearTimeout(timer);
    $minicart.trigger("count:update", response);
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (!response.error) {
            $minicart.find(".minicart-total").click();
        }
        var $addToCartMsg = $(".add-to-cart-messages");

        if ($addToCartMsg.length === 0) {
            $("body").append(
                "<div class=\"add-to-cart-messages\"></div>"
            );
        }

        if (!response.isMaxQuota) {
            var PdImage;
            if ($(".pdp-img").length) {
                PdImage = "<img src='" + $(".pdp-img").attr("src") + "'>";
            }
            var PdImageUrl = PdImage ? PdImage : "";
            $(".add-to-cart-messages")
                .empty()
                .append(
                    "<div class=\" align-items-center alert " + messageType + " add-to-basket-alert\" role=\"alert\">"
                    + "<div class=\"text-center \">" + PdImageUrl + "</div>"
                    + "<div class=\"text-center \">" + response.message + "</div>"
                    + "<div class=\"\"></div>"
                    + "</div>"
                );
        }

        var observer = new MutationObserver(function () {
            if (response && response.error) {
                $minicartPopover.find(".minicart-error-message").empty().append(response.message);
                $minicartPopover.find(".minicart-error").removeClass("d-none");
            }
        });

        observer.observe($minicartPopover[0], {childList: true});

        var $productSetAddToCart = $(".product-set-add-to-cart .add-to-cart");
        var $pdpSelect = $(".quantity-select.pdp-select");

        if ($productSetAddToCart.length && !$productSetAddToCart.hasClass("d-none")) {
            $pdpSelect.trigger("change");
        }

        timer = setTimeout(function () {
            $(".add-to-basket-alert").remove();
            $minicartPopover.find(".minicart-close-button").click();
            $minicartPopover.find(".minicart-error-message").empty();
            observer.disconnect();
        }, 5000);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $(".bundle-item").each(function () {
        childProducts.push({
            pid: $(this).find(".product-id").text(),
            quantity: parseInt($(this).find("label.quantity").attr("data-quantity"), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find(".product-option")
        .map(function () {
            var $elOption = $(this).find(".options-select");
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find("option[value='" + urlValue + "']")
                .data("value-id");
            return {
                optionId: $(this).data("option-id"),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: "GET",
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * @description Populates quantity drop-down
 * @param {object} item product line item object
 */
function populateQuantityDropdown(item) {
    var $currentDropdown = $("#quantity-" + item.UUID);
    var currentDropDownInfos = item.availabilityInfo;
    if ($currentDropdown.length && currentDropDownInfos && currentDropDownInfos.maxSaleQuantityFilteredBySteps) {
        var selectedOption = $currentDropdown.find(":selected").val();
        selectedOption = Number(selectedOption);
        $currentDropdown.empty();
        currentDropDownInfos.maxSaleQuantityFilteredBySteps.forEach(function (step) {
            var option = (selectedOption === step) ? "<option selected " : "<option ";
            option += "value='" + step + "'>" + step + "</option>";
            $currentDropdown.append(option);
        });
    }
}

/**
 * @description Display cart global error message
 * @param {string} errorMessage
 */
function showCartGlobalError(errorMessage) {
    if (errorMessage && errorMessage.length > 0) {
        $(".valid-cart-error").empty().text(errorMessage);
        $(".valid-cart-error").removeClass("d-none");
        $("cart-error").removeClass("d-none");
    }
    else {
        $(".valid-cart-error").empty();
        $(".valid-cart-error").addClass("d-none");
        $("cart-error").addClass("d-none");
    }
}

/**
 * @description Display cart global error message
 * @param {jQuery} $addToCartBtn - current add to cart button
 * @param {object} data - response data object
 */
function handleQuotaUpdate($addToCartBtn, data) {
    var message;
    var availabilityInfo = data.availabilityInfo;
    if (availabilityInfo.messages && availabilityInfo.messages.length) {
        message = availabilityInfo.messages[0];
    }
    var limitedStockMessage = message;

    // update availability message on PDP
    if (limitedStockMessage && limitedStockMessage.length > 0) {
        $(".avalability-messages").empty().text(limitedStockMessage);
    }

    // update quantities for all dropdowns and messages
    var generalMessage;
    data.cart.items.forEach(function (item) {
        if (item.availabilityInfo.generalMessages && item.availabilityInfo.generalMessages.length) {
            generalMessage = item.availabilityInfo.generalMessages[0];
        }
        $addToCartBtn.parents(".product-info").find(".js-product-error-" + item.UUID).empty();
        if (item.availabilityInfo.messages && item.availabilityInfo.messages.length > 0) {
            $addToCartBtn.parents(".product-info").find(".js-product-error-" + item.UUID)
                .html(`<div class="line-item-availability"><p class="line-item-attributes">${item.availabilityInfo.messages[0]}</p></div>`);
        }
        populateQuantityDropdown(item);
    });
    showCartGlobalError(generalMessage);

    // maj CTAs states
    if (availabilityInfo.maxSaleQuantityFilteredBySteps && availabilityInfo.maxSaleQuantityFilteredBySteps.length === 0) {
        // update add to cart btn
        $(".js-add-to-cart-main .add-to-cart").addClass("d-none");
        $(".js-add-to-cart-main .btn-out-of-stock").removeClass("d-none");
        $(".personalization-link-wrapper").attr("disabled", "disabled");
        $(".product-set-add-to-cart .add-to-cart").addClass("d-none");
        $(".product-set-add-to-cart .btn-out-of-stock").removeClass("d-none");

        $(".product-infos-container").find(".pdp-select").closest(".quantity").find(".select2-selection__rendered").text("0");
        $(".quantity-pdp").addClass("quantity-pdp-disabled");
        $(".quantity-select").addClass("quantity-select-disabled select2-hidden-accessible").prop("disabled", true);

        //remove availability messages
        if (availabilityInfo.isInStock === false || availabilityInfo.stockLimited) {
            $(".avalability-messages").empty().addClass("d-none");
        }
    } else {
        // filter dropdownlist by info.maxSaleQuantityFilteredBySteps
        var $currentDropdown = $(".quantity-select");
        var optionData = $(".quantity-select.pdp-select option:selected").data("url");
        $currentDropdown.empty();
        updateCTA(data.cart.items.pop());

        if (availabilityInfo.maxSaleQuantityFilteredBySteps) {
            availabilityInfo.maxSaleQuantityFilteredBySteps.forEach(function (step) {
                var option = "<option ";
                option += "value='" + step + "'";
                if (optionData) {
                    var optionDataUrl = optionData.replace(optionData.match(/quantity=[1-9]\d*/), `quantity=${step}`);
                    option += " data-url='" + optionDataUrl + "'";
                }
                option += ">" + step + "</option>";
                $currentDropdown.append(option);
            });
        }

        $(".product-detail .pdp-select").trigger("change");
    }
}

/**
 * @description Display cart global error message
 * @param {jQuery} $addToCartBtn - current add to cart button
 * @param {object} data - response data object
 */
function handleQuotaProductSetUpdate($addToCartBtn, data) {
    let availabilityInfo, limitedStockMessage, pid, $setItem, $setItemAvailabilityMessage, $setItemAddToCart, $currentDropdown;
    let $productSetAddToCart = $(".product-set-add-to-cart");

    for (let i = 0; i < data.availabilityInfo.length; i++) {
        availabilityInfo = data.availabilityInfo[i];
        pid = availabilityInfo.pid;
        $setItem = $(`.set-item[data-pid=${pid}]`);
        $setItemAvailabilityMessage = $setItem.find(".avalability-messages");
        $setItemAddToCart = $setItem.find(".js-add-to-cart-main");
        $currentDropdown = $setItem.find(".quantity-select");

        if (availabilityInfo.messages && availabilityInfo.messages.length) {
            limitedStockMessage = availabilityInfo.messages[0];
        }

        // update availability message on PDP
        if (limitedStockMessage && limitedStockMessage.length > 0) {
            $setItemAvailabilityMessage.empty().text(limitedStockMessage);
        }

        // update quantities for all dropdowns and messages
        var generalMessage;
        data.cart.items.forEach(function (item) {
            if (item.availabilityInfo.generalMessages && item.availabilityInfo.generalMessages.length) {
                generalMessage = item.availabilityInfo.generalMessages[0];
            }
            $addToCartBtn.parents(".product-info").find(".js-product-error-" + item.UUID).empty();
            if (item.availabilityInfo.messages && item.availabilityInfo.messages.length > 0) {
                $addToCartBtn.parents(".product-info").find(".js-product-error-" + item.UUID)
                    .html(`<div class="line-item-availability"><p class="line-item-attributes">${item.availabilityInfo.messages[0]}</p></div>`);
            }
            populateQuantityDropdown(item);
        });
        showCartGlobalError(generalMessage);

        // maj CTAs states
        if (availabilityInfo.maxSaleQuantityFilteredBySteps && availabilityInfo.maxSaleQuantityFilteredBySteps.length === 0) {
            // update add to cart btn
            $setItemAddToCart.find(".add-to-cart").addClass("d-none");
            $setItemAddToCart.find(".btn-out-of-stock").removeClass("d-none");
            $setItem.find(".personalization-link-wrapper").attr("disabled", "disabled");
            $productSetAddToCart.find(".add-to-cart").addClass("d-none");
            $productSetAddToCart.find(".btn-out-of-stock").removeClass("d-none");
            $setItem.find(".product-infos-container").find(".pdp-select").closest(".quantity").find(".select2-selection__rendered").text("0");
            $setItem.find(".quantity-pdp").addClass("quantity-pdp-disabled");
            $currentDropdown.addClass("quantity-select-disabled select2-hidden-accessible").prop("disabled", true);

            //remove availability messages
            if (availabilityInfo.isInStock === false || availabilityInfo.stockLimited) {
                $setItemAvailabilityMessage.empty().addClass("d-none");
            }
        } else {
            // filter dropdownlist by info.maxSaleQuantityFilteredBySteps
            let optionData = $currentDropdown.find("option:selected").data("url");

            $currentDropdown.empty();
            updateCTA(data.cart.items.pop());

            availabilityInfo.maxSaleQuantityFilteredBySteps.forEach(function (step) {
                let option = "<option ";
                option += "value='" + step + "'";

                if (optionData) {
                    var optionDataUrl = optionData.replace(optionData.match(/quantity=[1-9]\d*/), `quantity=${step}`);
                    option += " data-url='" + optionDataUrl + "'";
                }

                option += ">" + step + "</option>";
                $currentDropdown.append(option);
            });
        }
    }
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },

    focusChooseBonusProductModal: function () {
        $("body").on("shown.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal").siblings().attr("aria-hidden", "true");
            $("#chooseBonusProductModal .close").focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $("body").on("hidden.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal").siblings().attr("aria-hidden", "false");
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $("body").on("keydown", "#chooseBonusProductModal", function (e) {
            var focusParams = {
                event: e,
                containerSelector: "#chooseBonusProductModal",
                firstElementSelector: ".close",
                lastElementSelector: ".add-bonus-products"
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on("click", "[data-attr='color'] button", function (e) {
            e.preventDefault();

            if ($(this).attr("disabled")) {
                return;
            }
            var $productContainer = $(this).closest(".set-item");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".product-detail");
            }

            attributeSelect($(this).attr("data-url"), $productContainer);
        });
    },

    selectAttribute: function () {
        $(document).on("change", "select[class*='select-'], .options-select, input[name='variation-group']", function (e) {
            e.preventDefault();

            var $this = $(this);
            var $productContainer = $this.closest(".set-item");
            if (!$productContainer.length) {
                $productContainer = $this.closest(".product-detail");
            }
            attributeSelect(e.currentTarget.value, $productContainer, $this);

            if ($this.hasClass("caseof-input") && $this.parents(".caseof-wrapper")) {
                $(".caseof-wrapper").toggleClass("selected");
            }
        });
    },

    availability: function () {
        $(document).on("change", ".quantity-select", function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest(".product-detail");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".modal-content").find(".product-quickview");
            }

            if (!$productContainer.length && $(this).closest(".personalization-dialog").length) {
                $productContainer = $(".product-detail.product-wrapper");
            }

            if ($(".bundle-items", $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find("option:selected").data("url"),
                    $productContainer);
            }
        });
    },

    addToCart: function () {
        $(document).on("click", "button.add-to-cart, button.add-to-cart-global", function () {
            var $this = $(this);
            var isDigitalLoyaltyProduct = $this.hasClass("js-loyalty-premium");
            if ($this.closest(".suggested-product").length || $this.parents(".product-tile").length) {
                return;
            }

            var addToCartUrl;
            var pidsObj;
            var setPids;
            var pid = getPidValue($(this));
            var isMandatoryPersonalizable = $this.data("product-ismandatorypersonalizable");
            var $productSet = $(".product-set-detail[data-pid]");

            if ($productSet.length) {
                var productSetId = $productSet.attr("data-pid");
                var $setItems = $(".set-item[data-pid]");
                var productSetItems = [];

                $setItems.each(function() {
                    const $element = $(this);
                    const pid = $element.attr("data-pid");
                    productSetItems.push({pid});
                });
            }

            if ($(".product-detail").length && isMandatoryPersonalizable) {
                $.spinner().start();
                $("[data-target-personalization-modal]").trigger("click");
                return;
            }

            $("body").trigger("product:beforeAddToCart", this);

            if ($(".set-items").length && $this.parent().hasClass("product-set-add-to-cart")) {
                setPids = [];

                $(".product-detail").each(function () {
                    if (!$(this).hasClass("product-set-detail")) {
                        setPids.push({
                            pid: $(this).attr("data-pid"),
                            qty: $(this).find(".quantity-select").val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            var $productContainer = $(this).closest(".product-detail");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".quick-view-dialog").find(".product-detail");
            }

            addToCartUrl = getAddToCartUrl();
            var csrfToken = $("input[id='add-to-cart-csrf-token'").val();
            var form = {
                pid: pid,
                productSetId: productSetId,
                productSetItems: JSON.stringify(productSetItems),
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this)),
                csrf_token: csrfToken
            };

            if (!$(".bundle-item").length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger("updateAddToCartFormData", form);
            if (isDigitalLoyaltyProduct) {
                $.spinner().start();
            }
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: "POST",
                    data: form,
                    success: function (data) {
                        $("body").trigger("product:afterAddToCart", data);
                        var showLoyaltyAccountInfo = data && data.showLoyaltyAccountInfo ? data.showLoyaltyAccountInfo === true : false;
                        $(".account-popin .js-loyalty-account-info").toggleClass("d-none", !showLoyaltyAccountInfo);
                        $(".header .user-logged-in").toggleClass("user-loyalty-p", showLoyaltyAccountInfo);
                        var availabilityInfo = data ? data.availabilityInfo : null;
                        if (availabilityInfo) {
                            if (availabilityInfo.quotaEnabled) {
                                handleQuotaUpdate($this, data);
                            } else if (availabilityInfo.length > 0) {
                                handleQuotaProductSetUpdate($this, data);
                            }
                        }

                        handlePostCartAdd(data);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                        if (isDigitalLoyaltyProduct) {
                            $this.closest(".js-loyalty-premium-wrapper").addClass("d-none");
                            $(".js-cart-empty-loyalty").addClass("d-none");
                            $(".cart-content").removeClass("d-none");
                            updateCartTotals(data.cart);
                            if (data?.itemsHtml && $(".cart-page").length) {
                                var $productCardsWrapper = $(".cart-product-cards");
                                $productCardsWrapper.children().not(".loyalty-cart, .espot-banner-slot").remove();
                                $productCardsWrapper.append(data.itemsHtml);
                            }
                            $(".cart-listing-header-inner").empty();
                            $.spinner().stop();

                            // Handle having only digital product in cart
                            if (data.quantityTotal === 1) {
                                $(".js-loyalty-premium-wrapper-only").addClass("d-none");
                            }
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on("click", ".select-bonus-product", function () {
            var $choiceOfBonusProduct = $(this).parents(".choice-of-bonus-product");
            var pid = $(this).data("pid");
            var maxPids = $(".choose-bonus-product-dialog").data("total-qty");
            var submittedQty = parseInt($choiceOfBonusProduct.find(".bonus-quantity-select").val(), 10);
            var totalQty = 0;
            $.each($("#chooseBonusProductModal .selected-bonus-products .selected-pid"), function () {
                totalQty += $(this).data("qty");
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find(".product-option").data("option-id");
            var valueId = $choiceOfBonusProduct.find(".options-select option:selected").data("valueId");
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ""
                + "<div class='selected-pid row'"
                + "data-pid='" + pid + "'"
                + "data-qty='" + submittedQty + "'"
                + "data-optionID='" + (optionID || "") + "'"
                + "data-option-selected-value='" + (valueId || "") + "'"
                + ">"
                + "<div class='col-sm-11 col-9 bonus-product-name'>"
                + $choiceOfBonusProduct.find(".product-name").html()
                + "</div>"
                + "<div class='col-1'><i class='fa fa-times' aria-hidden='true'></i></div>"
                + "</div>"
                ;
                $("#chooseBonusProductModal .selected-bonus-products").append(selectedBonusProductHtml);
                $(".pre-cart-products").html(totalQty);
                $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
            } else {
                $(".selected-bonus-products .bonus-summary").addClass("alert-danger");
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on("click", ".selected-pid", function () {
            $(this).remove();
            var $selected = $("#chooseBonusProductModal .selected-bonus-products .selected-pid");
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data("qty"), 10);
                });
            }

            $(".pre-cart-products").html(count);
            $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
        });
    },
    enableBonusProductSelection: function () {
        $("body").on("bonusproduct:updateSelectButton", function (e, response) {
            $("button.select-bonus-product", response.$productContainer).attr("disabled",
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $("button.select-bonus-product", response.$productContainer).data("pid", pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on("click", ".show-more-bonus-products", function () {
            var url = $(this).data("url");
            $(".modal-content").spinner().start();
            $.ajax({
                url: url,
                method: "GET",
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $(".modal-body").append(parsedHtml.body);
                    $(".show-more-bonus-products:first").remove();
                    $(".modal-content").spinner().stop();
                },
                error: function () {
                    $(".modal-content").spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on("click", ".add-bonus-products", function () {
            var $readyToOrderBonusProducts = $(".choose-bonus-product-dialog .selected-pid");
            var queryString = "?pids=";
            var url = $(".choose-bonus-product-dialog").data("addtocarturl");
            var $minicartQtyResource = $(".minicart-quantity").attr("data-resource");
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data("qty"), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data("optionid") && $(this).data("option-selected-value")) {
                        option = {};
                        option.optionId = $(this).data("optionid");
                        option.productId = $(this).data("pid");
                        option.selectedValueId = $(this).data("option-selected-value");
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data("pid"),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($(".pre-cart-products").html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + "&uuid=" + $(".choose-bonus-product-dialog").data("uuid");
            queryString = queryString + "&pliuuid=" + $(".choose-bonus-product-dialog").data("pliuuid");
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: "POST",
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $("#chooseBonusProductModal").modal("hide");
                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class='add-to-cart-messages'></div>");
                        }
                        $(".add-to-cart-messages").append(
                            "<div class='alert alert-danger add-to-basket-alert text-center'"
                            + " role='alert'>"
                            + data.errorMessage + "</div>"
                        );
                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                        }, 3000);
                    } else {
                        $(".configure-bonus-product-attributes").html(data);
                        $(".bonus-products-step2").removeClass("hidden-xl-down");
                        $("#chooseBonusProductModal").modal("hide");

                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class='add-to-cart-messages'></div>");
                        }
                        var $minicartQty = data.totalQty < 100 ? data.totalQty : $minicartQtyResource;
                        $(".minicart-quantity").html($minicartQty);
                        $(".add-to-cart-messages").append(
                            "<div class='alert alert-success add-to-basket-alert text-center'"
                            + " role='alert'>"
                            + data.msgSuccess + "</div>"
                        );
                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                            if ($(".cart-page").length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    populateQuantityDropdown: populateQuantityDropdown,
    handleQuotaUpdate: handleQuotaUpdate,
    showCartGlobalError: showCartGlobalError
};
